import Color from '../data/Color';
import ColorBuilder from '../utils/ColorBuilder';
import { Container, getMovieClipByName, MovieClip } from '../utils/utils';

export default class JerseyImages {
  // ================================================================================================
  // properties
  // ================================================================================================
  thirdImagesHideTargets: MovieClip[];

  private mainImages: MovieClip[];

  private secondImages: MovieClip[];

  private thirdImages: MovieClip[];

  private isThirdColorVisible: boolean;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(container: Container) {
    this.mainImages = JerseyImages.InitImages(container, 'main');
    this.secondImages = JerseyImages.InitImages(container, 'second');
    this.thirdImages = JerseyImages.InitImages(container, 'third');
    this.isThirdColorVisible = true;
  }

  // ----------------------------------------------------------------------------------------------
  set mainColor(value: Color) {
    JerseyImages.ApplyColorTo(this.mainImages, value);
    this.mainVisible = true;
  }

  // ----------------------------------------------------------------------------------------------
  set mainVisible(value: boolean) {
    JerseyImages.SetVisible(this.mainImages, value);
  }

  // ----------------------------------------------------------------------------------------------
  set secondColor(value: Color) {
    JerseyImages.ApplyColorTo(this.secondImages, value);
    this.secondVisible = true;
  }

  // ----------------------------------------------------------------------------------------------
  set secondVisible(value: boolean) {
    JerseyImages.SetVisible(this.secondImages, value);
  }

  // ----------------------------------------------------------------------------------------------
  set thirdColor(value: Color) {
    JerseyImages.ApplyColorTo(this.thirdImages, value);
    JerseyImages.ApplyColorTo(this.thirdImagesHideTargets, value);
    this.thirdVisible = true;
  }

  // ----------------------------------------------------------------------------------------------
  get thirdVisible(): boolean {
    return (this.isThirdColorVisible);
  }

  // ----------------------------------------------------------------------------------------------
  set thirdVisible(value: boolean) {
    this.isThirdColorVisible = value;

    if (value) {
      JerseyImages.SetVisible(this.thirdImages, value);
      JerseyImages.SetVisible(this.thirdImagesHideTargets, value);
      return;
    }

    const hideTargets = this.thirdImagesHideTargets || this.thirdImages;
    JerseyImages.SetVisible(hideTargets, value);
  }

  // ----------------------------------------------------------------------------------------------
  set visible(value: boolean) {
    JerseyImages.SetVisible(this.mainImages, value);
    JerseyImages.SetVisible(this.secondImages, value);
    JerseyImages.SetVisible(this.thirdImages, value);
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private static ApplyColorTo(images: MovieClip[], value: Color): void {
    if (!images) {
      return;
    }

    images.forEach((image) => {
      ColorBuilder.Apply(image, value);
    });
  }

  // ----------------------------------------------------------------------------------------------
  private static CreateImageName(baseName: string, index?: number): string {
    // example format: 'jerseys_main_0_display'
    const indexString = index !== undefined ? `_${index.toString(10)}` : '';
    return (`jerseys_${baseName}${indexString}_display`);
  }

  // ----------------------------------------------------------------------------------------------
  private static InitImages(container: Container, baseName: string): MovieClip[] {
    const images: MovieClip[] = [];
    let image = getMovieClipByName(container, JerseyImages.CreateImageName(baseName));
    let index = 0;
    while (image) {
      images.push(image);
      image = getMovieClipByName(container, JerseyImages.CreateImageName(baseName, index));
      index += 1;
    }
    return (images);
  }

  // ----------------------------------------------------------------------------------------------
  private static SetVisible(images: MovieClip[], value: boolean): void {
    if (!images) {
      return;
    }

    images.forEach((image) => {
      image.visible = value;
    });
  }
}
